import HeroListItem from './HeroListItem';

export default HeroListItem;
